import { BROWSER_DEFAULT_AUDIO_DEVICE_ID } from './enum';

/**
 * Ask Chrome for a specific microphone (the Audio Settings pick, or "default").
 * Without a device id, Chrome may reopen the last mic it used instead of the current OS default.
 */
export function getInspectMicrophoneOptions(deviceId?: string | null): MediaStreamConstraints {
  return {
    audio: {
      deviceId: { exact: deviceId || BROWSER_DEFAULT_AUDIO_DEVICE_ID },
    },
  };
}
